import type { ButtonProps } from '../core-components/Button';
import Link from 'next/link';

export type SimpleCta = {
  label: string;
  href: string;
  variant?: ButtonProps['variant'];
};

export type Cta = SimpleCta | ButtonProps;
export type CtaList = Cta | Cta[];

export function convertCtaToButtonProps(cta: Cta): ButtonProps;
export function convertCtaToButtonProps(cta?: undefined): undefined;
export function convertCtaToButtonProps(
  cta?: Cta | undefined,
  useNativeLink?: boolean,
): ButtonProps | undefined;
export function convertCtaToButtonProps(
  cta?: Cta | undefined,
  useNativeLink?: boolean,
): ButtonProps | undefined {
  if (typeof cta === 'undefined') {
    return undefined;
  }

  if (!('href' in cta)) {
    return cta;
  }

  const { href, label, ...others } = cta;

  return {
    asChild: true,
    children: useNativeLink ? (
      <Link href={href}>{label}</Link>
    ) : (
      <a href={href}>{label}</a>
    ),
    ...others,
  };
}

export function convertCtaListToButtonProps(ctaList: CtaList): ButtonProps[];
export function convertCtaListToButtonProps(ctaList?: undefined): undefined;
export function convertCtaListToButtonProps(
  ctaList?: CtaList | undefined,
): ButtonProps[] | undefined;
export function convertCtaListToButtonProps(
  ctaProps?: CtaList,
): ButtonProps[] | undefined {
  if (typeof ctaProps === 'undefined') {
    return undefined;
  }

  const ctaArray = Array.isArray(ctaProps) ? ctaProps : [ctaProps];
  return ctaArray.map<ButtonProps>(cta => convertCtaToButtonProps(cta));
}
